import { NgModule } from '@angular/core';
import { provideConfig, LoginEvent, LogoutEvent } from '@spartacus/core';
import { CartAddEntrySuccessEvent, CartRemoveEntrySuccessEvent } from '@spartacus/cart/base/root';
import { NavigationEvent, ProductDetailsPageEvent } from '@spartacus/storefront';
import { BaseTmsModule, TmsConfig } from '@spartacus/tracking/tms/core';
import { GtmModule } from '@spartacus/tracking/tms/gtm';
import { environment } from 'src/environments/environment';
import { MarkettingCenterLinkDownlaodEvent, QuickorderSearchSuccess } from 'src/app/store/custome-spartacus-events';
import { KnBrGtmCollectorService } from '../services/kn-br-gtm-collector.service';

@NgModule({
  declarations: [],
  imports: [BaseTmsModule.forRoot(), GtmModule],
  providers: [
    provideConfig({
      tagManager: {
        gtm: {
          collector: KnBrGtmCollectorService,
          gtmId: environment.gtmId,
          events: [
            NavigationEvent,
            ProductDetailsPageEvent,
            LoginEvent,
            LogoutEvent,
            CartAddEntrySuccessEvent,
            CartRemoveEntrySuccessEvent,
            QuickorderSearchSuccess,
            MarkettingCenterLinkDownlaodEvent,
          ],
        },
      },
    } as TmsConfig),
  ],
})
export class TagManagementFeatureModule {}
